import {picker} from "./picker.js";
import {datePicker} from "./picker.date.js";

export function pickadate($) {
    let Picker = picker($);
    datePicker(Picker, $);
    return $;
};
